import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import Cookies from 'js-cookie';
import InlineCta from 'components/Core/InlineCta';
import { Col, Row } from 'components/Core/Grid';
import { STIcon } from 'components/Brand/Icons/STIcon';
import Button from 'components/Core/Button';
import useDefaultGatedRichTextForm from 'hooks/useDefaultGatedRichTextForm';
import toolboxUser from 'hooks/useToolboxStorage';
import useBlur from './useBlur';
import './blur.less';

export const ExpandContent = ({ onClick, className = '' }) => {
  const ref = useRef();
  useBlur(ref, true);
  return (
    <ExpandContainer className={`expand-container ${className}`} ref={ref} onClick={onClick}>
      <ExpandedRow gutter={[24, 0]}>
        <Col xs={24} sm={24} md={16} lg={16}>
          <ExpandButton type="tertiary" onClick={onClick}>
            Expand to read more{' '}
            <STIcon className="collapse-arrow" type="icon-caret" stroke="white" width="13px" />
          </ExpandButton>
        </Col>
      </ExpandedRow>
    </ExpandContainer>
  );
};

export const GatedForm = ({ onSuccess }) => {
  const subscribeForm = useDefaultGatedRichTextForm();
  const ref = useRef();
  useBlur(ref);
  return Cookies.get('email') || toolboxUser.isLoggedIn() ? (
    <ExpandContent className="gated-content" onClick={onSuccess} />
  ) : (
    <ExpandContainer ref={ref} className="expand-container gated-content">
      <EmailContainer>
        <InlineCta
          title={subscribeForm.formTitle}
          modalForm={{ ...subscribeForm, onSuccess, theme: 'dark' }}
        />
      </EmailContainer>
    </ExpandContainer>
  );
};

export const expandableStyles = css`
  max-height: 570px;
  overflow: hidden;
  .styled-rich-text {
    max-height: 570px;
    overflow: hidden;
  }
  .richtext-sidebar--container {
    position: static !important;
  }

  @media (max-width: 767px) {
    max-height: 680px;
    .styled-rich-text {
      max-height: 680px;
    }
  }
`;

const EmailContainer = styled.div`
  position: absolute;
  bottom: 0;
  z-index: 2;
  width: 100%;
  & > div {
    padding: 0px;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: end;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 70%);
  }
  .section-try-demo--container {
    margin: 0;
    padding: 0;
    .data-layer-form {
      .Email {
        flex: 2;
      }
      div:last-child {
        flex: 1;
        button {
          width: 100%;
        }
      }
    }
    .section-try-demo--title {
      color: var(--dark) !important;
      font-size: var(--font-size-h3);
    }
    @media (max-width: 767px) {
      > div:last-child {
        margin: 0;
        .dynamic-form--container {
          padding: 0;
        }
      }
      .section-try-demo--title {
        font-size: var(--font-size-mobile-h3) !important;
      }
    }
  }
`;

const ExpandContainer = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 1;
  @media (max-width: 767px) {
    &.gated-content {
      .blur-container {
        height: 370px;
        background: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 30%
        );
      }
    }
  }
`;

const ExpandedRow = styled(Row)`
  width: 100%;
  position: absolute;
  bottom: 0;
  margin: 0 !important;
  & > div {
    padding: 0 !important;
    width: 100%;
  }
`;
const ExpandButton = styled(Button)`
  width: 100%;
  font-size: var(--font-size-p);
  font-weight: var(--font-weight-300);
  box-shadow: none;
  .collapse-arrow {
    margin-left: 15px;
    transform: rotate(180deg);
  }
`;
